module.exports = __webpack_public_path__ + "img/mob_product.a4ddbc4c.png";